export const measurementUnits = {
  KG: 'KG',
  PC: 'PC',
  PCS: 'PCS',
  G: 'G',
  ML: 'ML',
}


